import { createSelector, createStructuredSelector } from 'reselect';
import _ from 'lodash';

import { StoreType } from '@tock/shared/utils/connect';

export const guestGroupsSelector = createStructuredSelector<
  StoreType,
  { guestGroups: StoreType['guestGroups'] }
>({
  guestGroups: (state: StoreType): StoreType['guestGroups'] => {
    return state.guestGroups;
  },
});

export const dynamicGroupsSelector = createSelector(guestGroupsSelector, (guestGroups) =>
  _.filter(guestGroups.guestGroups.data, (guestGroup) => {
    return guestGroup.type === 'RULE_BASED';
  })
);

export const guestGroupsByIdSelector = createSelector(guestGroupsSelector, (guestGroupsState) => {
  const { data } = guestGroupsState.guestGroups;
  return _.keyBy(data, 'id');
});
